import type { FaireProductEntity } from "../../entity_types/product";

export const p_6ybx9bfxem: FaireProductEntity = {
  token: "p_6ybx9bfxem",
  type: "product",
  name: "Bams & Bubbly Mahjong Mat",
  brandToken: "b_vbyfesg45s",
  brandName: "Anders Ruff Design Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/2d424533fcf5e99573caae254aed85f3bf3fe643d755928e6fbca4a98367bf2d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/10a600bef524a287d9739da08fb722c7d82c59fc4b023dc4c19d2649395f5de0.jpeg",
    "https://cdn.faire.com/fastly/454eee2098ce10e53f3856a9465791ddc9a01838f7cfc31c58318661718dfd64.jpeg",
  ],
  priceDollars: 48,
  description:
    'Pop the cork. Set the table.\n\nPart of The Bmas & Bubbly Collection, the Bams & Bubbly mat brings the celebratory spirit of a champagne toast to every game night. A vibrant palette of pink and orange is accented with whimsical bubbly details — a playful nod to the tile set it was designed to complement. \n\nWhether you\'re hosting a weekly game night, a girls\' weekend, or gifting the hostess who has everything, this mat sets a table that feels like a party before a single tile is drawn.\n\nMade For the Player Who…\n• You treat every game night like a celebration worth dressing for\n• Pink, orange, and champagne tones are your love language\n• You love designs that coordinate with your full tile set\n• Hostess gifting is your specialty and you want something truly memorable\n• Your game nights always come with something bubbly\n\nDesigned exclusively by Anders Ruff Design Co. to coordinate with the full collection — from tile sets to card covers — so every detail of your table feels intentional.\n\nDetails\n• Sizes: 33" x 33" Standard or 20.9" x 20.9" Travel\n• Premium neoprene fabric top with non-slip rubber backing\n• Smooth surface for easy tile movement\n• Vibrant full-color printed design\n• Lightweight + travel friendly\n• Ships rolled, will arrive crease-free\n• Includes drawstring carry bag\n• Designed exclusively by Anders Ruff Design Co.\n\nPLAY BEAUTIFULLY · GATHER IN STYLE \n\n',
  tags: [],
  msrpDollars: 96,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:29.435Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
